<template>
	<div class="indexView">
		<el-container>
			<el-main>
				<HeaderRow selUrl="custom"></HeaderRow>
				<div class="banner" v-if="navList[1]&&navList[1].icon_image">
					<el-image style="width: 100%; height: 300px" fit="cover" :src="navList[1].icon_image"></el-image>
				</div>
				<div class="breadcrumb">
					<div class="backItem" @click="()=>$router.back()"><i class="el-icon-arrow-left">返回</i></div>
					<el-breadcrumb separator="/">
						<el-breadcrumb-item to="/">首页</el-breadcrumb-item>
						<el-breadcrumb-item to="/custom">定制课程</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="lecturerDiv">
					<div class="lecturerItem" v-for="(item, index) in 8" :key="`${index}`" @click="gotoLecturerDetail(item)">
						<img :src="require('@/assets/custom/photo.png')" />
						<div class="info">
							<p>彭老师 <span>毕业于XXX大学</span></p>
							<p>------------</p>
							<p>
								曾任职于XXX学校，专注于进行高中物理的培训和教育，上课氛围幽默有趣、形象生动，可以有效的带动学生学习的积极性，教育知识层层深入，简洁明了。教学理念为，学习是快乐的，但他从不轻松。</p>
						</div>
					</div>
				</div>
				<FooterRow></FooterRow>
			</el-main>
		</el-container>
	</div>
</template>

<script>
	import indexjs from "./index.js";
	import {
		copy
	} from "clipboard";
	import HeaderRow from "@/components/headerRow.vue";
	import FooterRow from "@/components/footerRow.vue";

	export default {
		methods: {
			copy,
		},
		...indexjs,
		components: {
			HeaderRow,
			FooterRow,
		},
		computed: {},

	};
</script>

<style lang="scss" scoped>
	@import "./index.scss";
</style>